import React from 'react';

import { Lottie } from '@whelk/components';
import darkLottie from './json/theme-dark.json';
import lightLottie from './json/theme-light.json';

export const DarkThemeLottie = () => (
  <Lottie
    style={{ padding: '1px 0px', width: '32px' }}
    data={darkLottie}
    loop={false}
    play={true}
  />
);

export const LightThemeLottie = () => (
  <Lottie
    style={{ padding: '1px 0px', width: '32px' }}
    data={lightLottie}
    loop={false}
    play={true}
  />
);
